import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62108930"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "aria-label": "Pagination",
  class: "w-fit mt-4 mx-auto"
}
const _hoisted_2 = { class: "inline-flex items-center -space-x-px mx-auto" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Previous", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "page-button blank"
}, "...", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "page-button blank"
}, "...", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Next", -1))

import { Icon } from "@toruslabs/vue-components";
import { computed, ref } from "vue";

type PaginationClassesKey = "listContainer";


export default /*#__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    items: {},
    perPage: { default: 10 },
    classes: { default: () => ({}) },
    pagesToShow: { default: null }
  },
  setup(__props: any) {

const props = __props;



const currentPage = ref(1);

const pages = computed(() => {
  const totalPages = Math.ceil(props.items.length / props.perPage);
  const pageDifference = props.pagesToShow ? Math.ceil(props.pagesToShow / 2) - 2 : 0;
  const pageArray = Array.from({ length: totalPages }, (_, i) => {
    const value = i + 1;
    return {
      value,
      show: props.pagesToShow === null ? true : Math.abs(currentPage.value - value) <= pageDifference,
    };
  });

  return pageArray;
});

const finalItems = computed(() => {
  const start = (currentPage.value - 1) * props.perPage;
  const finalList = props.items.slice(start, start + props.perPage);
  return finalList;
});

const hideFirstPage = computed(() => {
  if (props.pagesToShow === null) return true;
  return currentPage.value < Math.ceil(props.pagesToShow / 2);
});

const hideLastPage = computed(() => {
  if (props.pagesToShow === null) return true;
  const lastPages = pages.value.length - Math.ceil(props.pagesToShow / 2) + 1;
  return currentPage.value > lastPages;
});

const prev = () => {
  const tempPage = currentPage.value - 1;
  currentPage.value = tempPage <= 0 ? 1 : tempPage;
};

const next = () => {
  const tempPage = currentPage.value + 1;
  currentPage.value = tempPage > pages.value.length ? pages.value.length : tempPage;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.classes?.listContainer])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finalItems.value, (item, index) => {
        return _renderSlot(_ctx.$slots, "default", {
          key: index,
          item: item
        })
      }), 128))
    ], 2),
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            type: "button",
            class: "page-button rounded-l-lg",
            onClick: prev
          }, [
            _hoisted_3,
            _createVNode(_unref(Icon), { name: "chevron-left-solid-icon" })
          ])
        ]),
        _createElementVNode("li", {
          class: _normalizeClass({ hidden: hideFirstPage.value })
        }, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["page-button", { active: currentPage.value === 1 }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (currentPage.value = 1))
          }, "1", 2)
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass({ hidden: hideFirstPage.value })
        }, _hoisted_5, 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (n) => {
          return (_openBlock(), _createElementBlock("li", {
            key: n.value,
            class: _normalizeClass({ hidden: !n.show })
          }, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["page-button", { active: currentPage.value === n.value }]),
              onClick: ($event: any) => (currentPage.value = n.value)
            }, _toDisplayString(n.value), 11, _hoisted_6)
          ], 2))
        }), 128)),
        _createElementVNode("li", {
          class: _normalizeClass({ hidden: hideLastPage.value })
        }, _hoisted_8, 2),
        _createElementVNode("li", {
          class: _normalizeClass({ hidden: hideLastPage.value })
        }, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["page-button", { active: currentPage.value === pages.value[pages.value.length - 1]?.value }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (currentPage.value = pages.value[pages.value.length - 1]?.value))
          }, _toDisplayString(pages.value[pages.value.length - 1]?.value), 3)
        ], 2),
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            type: "button",
            class: "page-button rounded-r-lg",
            onClick: next
          }, [
            _hoisted_9,
            _createVNode(_unref(Icon), { name: "chevron-right-solid-icon" })
          ])
        ])
      ])
    ])
  ], 64))
}
}

})